import { useEffect, useRef } from 'react';
import { insights } from '../../../mocks/portfolio';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { attachTilt } from '../../../hooks/useTiltCards';
import SectionHeading from '../../../components/base/SectionHeading';

export default function InsightsRow() {
  const revealRef = useScrollReveal<HTMLDivElement>({ stagger: 0.12 });
  const tiltRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!tiltRef.current) return;
    return attachTilt(tiltRef.current, 4);
  }, []);

  return (
    <section
      ref={revealRef}
      className="relative bg-[#070709] text-white py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <SectionHeading
            eyebrow="Field notes"
            title="What we’re reading and writing."
            description="Essays, theses and observations from our partners — on the frontier industries we believe in."
          />
          <a
            href="#"
            className="gsap-reveal inline-flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white transition-colors"
          >
            All writing
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div ref={tiltRef} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {insights.map((article) => (
            <article
              key={article.title}
              className="gsap-reveal tilt-card group cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-white/10 hover-glow">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 liquid-glass px-3 py-1 rounded-full text-[11px] font-mono uppercase tracking-widest tilt-lift">
                  {article.category}
                </span>
              </div>
              <div className="mt-5">
                <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40 mb-3">
                  {article.date} · {article.readTime}
                </div>
                <h3 className="font-display text-xl md:text-2xl text-white/90">
                  <span className="title-shimmer inline-block">{article.title}</span>
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}